import React from 'react';

function Page2() {
  return (
    <div>This is Incomplete Page...</div>
  )
}

export default Page2;